export const matchFilterMixin = {
  data() {
    return {
      matchFormLabel: {
        action: 'Action',
        accountNo: 'Account No.',
        policyNo: 'Policy No.',
        tranType: 'Transaction Type',
        documentNo: 'Document No.',
        includeTranWithZero: 'Include Transactions with Zero Balance (0.00)',
        branch: 'Branch',
        fund: 'Fund',
        vehregNo: 'Vehicle Reg No.',
        coverNoteNo: 'Cover Note No.',
        baseTranType: 'Base Transaction Type',
        baseDocumentNo: 'Base Document No.',
        contraJrnlNo: 'Contra Journal No.',
        selectedTranType: 'Selected Transaction Type',
        selectedDocNo: 'Selected Document No.',
        matchedDate: 'Matched Date'
      },
      matchForm: {
        action: '',
        accountNo: '',
        policyNo: '',
        documentNo: '',
        tranType: '',
        includeTranWithZero: false,
        branch: '',
        fund: '',
        vehregNo: '',
        coverNoteNo: '',
        contraJrnlNo: '',
        baseTranType: '',
        baseDocumentNo: '',
        selectedTranType: '',
        selectedDocNo: '',
        matchedDate: null,
        matchedDateDisp: null

      },
      action: [
        { text: 'Match', value: 'M' },
        { text: 'Match Commission', value: 'C' },
        { text: 'Match RBC', value: 'R' }
      ],
      tranType: [
        { text: 'Z - Payment', value: 'Z' },
        { text: 'Y - Receipt', value: 'Y' },
        { text: 'A - Adjustment Debit Note', value: 'A' },
        { text: 'M - Direct Business Debit Note', value: 'M' },
        { text: 'N - Coinsurance Outward Debit Note', value: 'N' },
        { text: 'O - Reinsurance Inward Debit Note', value: 'O' },
        { text: 'P - Reinsurance Outward Debit Note', value: 'P' },
        { text: 'Q - Miscellaneous Debit Note', value: 'Q' },
        { text: 'W - Claims Debit Note', value: 'W' },
        { text: 'B - Adjustment Credit Note', value: 'B' },
        { text: 'R - Direct Business Credit Note', value: 'R' },
        { text: 'S - Coinsurance Outward Credit Note', value: 'S' },
        { text: 'T - Reinsurance Inward Credit Note', value: 'T' },
        { text: 'U - Reinsurance Outward Credit Note', value: 'U' },
        { text: 'V - Miscellaneous Credit Note', value: 'V' },
        { text: 'X - Claims Credit Note', value: 'X' }
      ],
      branches: []
    }
  },
  methods: {
    doClearFilters() {
      this.resetValidator()
      var thisPage = this
      Object.keys(this.matchForm).forEach(function(key, index) {
        thisPage.matchForm[key] = ''
      })
      this.matchForm.action = 'M'
      this.matchForm.tranType = 'Y'
      this.matchForm.includeTranWithZero = false
      // this.performSearch()
      this.isFiltered = false
      this.panel = [0]
      this.items = []
    },
    doFilters() {
      this.loading = true
      this.$validator.validateAll('matchForm').then(result => {
        if (result) {
          this.commonValidate(this.matchForm).then(result => {
            if (result) {
              this.isFiltered = true
              this.panel = []
              this.performSearch()
            }
          })
        } else {
          this.loading = false
          this.promptFieldCheck()
        }
      })
    },
    doClearFiltersMchDet() {
      this.resetMessages()
      this.resetValidator()
      this.showErrorDialog = false
      var thisPage = this
      Object.keys(this.matchForm).forEach(function(key, index) {
        thisPage.matchForm[key] = ''
      })
      this.performSearchMchDet()
    },
    doFiltersMchDet() {
      this.showErrorDialog = false
      this.resetMessages()
      this.$validator.validateAll('matchForm').then(result => {
        if (result) {
          this.performSearchMchDet()
          // this.commonValidate(this.matchForm).then(result => {
          //   if (result) {
          //     this.performSearchMchDet()
          //   }
          // })
        }
      })
    }
  }
}
